import React, {Component} from 'react';
import {createRefetchContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import UpdateError from '../../mutations/mission_control/update_error_mutation';
import TextAreaFoldout from '../../forecast-app/shared/components/inputs/textarea_foldout';
import {createToast} from '../../forecast-app/shared/components/toasts/another-toast/toaster';
import {Scrollbars} from 'react-custom-scrollbars';
import Dropdown from '../../forecast-app/shared/components/dropdowns/dropdown';
import {EMPTY_STATE} from '../../constants';
import EmptyState from '../../forecast-app/shared/components/empty-states/empty_state';
import Util from '../../forecast-app/shared/util/util';

class bugDuty extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: null,
			FAB_FEW: 'The Fabulous Few',
			LAST_CALL: 'Last Call Legacy',
			GEEK_SQUAD: 'Geek Squad',
			CRISTINA: 'Cristina is Cool',
			MOBILE: 'Mobile',
			UNKNOWN: 'Unknown',
			CLOSED: 'Closed',
			fadeTask: null,
		};
	}

	UNSAFE_componentWillMount() {
		const hash = window.location.hash;
		this.setLocation(hash);
	}

	setLocation(hash) {
		let searchString = '';
		if (hash === '#geek_squad') {
			this.setState({selectedTab: this.state.GEEK_SQUAD});
			searchString = 'GEEK_SQUAD';
		} else if (hash === '#the_fabulous_few') {
			this.setState({selectedTab: this.state.FAB_FEW});
			searchString = 'FAB_FEW';
		} else if (hash === '#last_call_legacy') {
			this.setState({selectedTab: this.state.LAST_CALL});
			searchString = 'LAST_CALL';
		} else if (hash === '#cristina_is_cool') {
			this.setState({selectedTab: this.state.CRISTINA});
			searchString = 'CRISTINA';
		} else if (hash === '#mobile') {
			this.setState({selectedTab: this.state.MOBILE});
			searchString = 'MOBILE';
		} else if (hash === '#unknown' || hash === '') {
			this.setState({selectedTab: this.state.UNKNOWN});
			searchString = 'UNKNOWN';
		} else if (hash === '#closed') {
			this.setState({selectedTab: this.state.CLOSED});
			searchString = 'CLOSED';
		}
		this.props.relay.refetch({searchString});
	}

	handleFixed(e) {
		if (e.notes === null || e.notes === undefined || e.notes === '') {
			createToast({duration: 10000, message: 'You have to enter a note before closing.'});
		} else {
			Util.CommitMutation(UpdateError, {
				id: e.actualId,
				fixed: !e.fixed,
			});
		}
	}

	handleExclude(e) {
		if (e.notes === null || e.notes === undefined || e.notes === '') {
			createToast({duration: 10000, message: 'You have to enter a note before closing.'});
		} else {
			Util.CommitMutation(UpdateError, {
				id: e.actualId,
				excludeFromStats: !e.excludeFromStats,
			});
		}
	}

	handleNotes(e, notes) {
		let skip = false;

		if (!e.notes && notes === '') {
			skip = true;
		}

		if (e.notes === notes) {
			skip = true;
		}

		if (!skip) {
			Util.CommitMutation(UpdateError, {
				id: e.actualId,
				notes: notes,
			});
		}
	}

	handleTeam(e, team) {
		if (team.value !== e.team) {
			this.setState({fadeTask: e.id});
			Util.CommitMutation(UpdateError, {
				id: e.actualId,
				team: team.value,
			});
			setTimeout(() => {
				this.setState({fadeTask: null});
			}, 1000);
		}
	}

	handleErrorTypeChange(e, type) {
		if (type.value !== e.type) {
			Util.CommitMutation(UpdateError, {
				id: e.actualId,
				knownType: type.label,
			});
		}
	}

	changeTab(selectedTab) {
		let newHash = '';
		if (selectedTab === this.state.GEEK_SQUAD) {
			newHash = '#geek_squad';
		} else if (selectedTab === this.state.FAB_FEW) {
			newHash = '#the_fabulous_few';
		} else if (selectedTab === this.state.LAST_CALL) {
			newHash = '#last_call_legacy';
		} else if (selectedTab === this.state.CRISTINA) {
			newHash = '#cristina_is_cool';
		} else if (selectedTab === this.state.MOBILE) {
			newHash = '#mobile';
		} else if (selectedTab === this.state.UNKNOWN) {
			newHash = '#unknown';
		} else if (selectedTab === this.state.CLOSED) {
			newHash = '#closed';
		}
		const newUrl = 'bug-duty' + newHash;
		this.props.history.replace(newUrl);
		this.setLocation(newHash);
	}

	getHeader = () => {
		const allTabs = [this.state.UNKNOWN, this.state.FAB_FEW, this.state.LAST_CALL, this.state.GEEK_SQUAD, this.state.CRISTINA, this.state.MOBILE, this.state.CLOSED];

		return (
			<div className="bugduty-wrapper">
				<div className="tabs">
					{allTabs.map(tab => (
						<div key={tab} className={'tab' + (this.state.selectedTab === tab ? ' active' : '')} onClick={() => this.changeTab(tab)} data-cy={tab.split('_')[0]}>
							{tab.replace(/_/g, ' ')}
						</div>
					))}
				</div>
			</div>
		);
	};

	getBugsList() {
		let team = null;
		if (this.state.selectedTab === this.state.GEEK_SQUAD) {
			team = 'GEEK_SQUAD';
		} else if (this.state.selectedTab === this.state.FAB_FEW) {
			team = 'FAB_FEW';
		} else if (this.state.selectedTab === this.state.LAST_CALL) {
			team = 'LAST_CALL';
		} else if (this.state.selectedTab === this.state.CRISTINA) {
			team = 'CRISTINA';
		} else if (this.state.selectedTab === this.state.MOBILE) {
			team = 'MOBILE';
		} else if (this.state.selectedTab === this.state.CLOSED) {
			team = 'CLOSED';
		}

		const errors = this.props.viewer.missionControlData.errorList.filter(e => {
			if (team === 'CLOSED') {
				return e.fixed === true;
			} else {
				return e.team === team && e.fixed === false;
			}
		});

		const allTeams = [
			{value: 'FAB_FEW', label: 'The Fabulous Few'},
			{value: 'LAST_CALL', label: 'Last Call Legacy'},
			{value: 'GEEK_SQUAD', label: 'Geek Squad'},
			{value: 'CRISTINA', label: 'Cristina is Cool'},
			{value: 'MOBILE', label: 'Mobile'},
		];
		const errorTypes = this.props.viewer.missionControlData.knownErrorTypes.map(et => {
			return {value: et.name, label: et.name};
		});

		return (
			<Scrollbars>
				{errors && errors.length !== 0 ? (
					<table className={'mission-control-bug-duty-table'} ref={el => (this.table = el)}>
						<thead>
							<tr>
								<th className={'extra-width-60'}>Close</th>
								<th className={'extra-width-60'}>Id</th>
								<th className={'extra-width-100'}>Updated By</th>
								<th className={'extra-width-150'}>Time</th>
								<th>Who</th>
								<th className={'extra-width-150'}>Where</th>
								<th className={'extra-padding'}>Notes</th>
								<th className={'extra-width-250'}>CorrelationId</th>
								<th>Sentry</th>
								<th>LogRocket</th>
								<th className={'extra-padding'}>Team</th>
								<th className={'extra-padding'}>Known Error</th>
								<th className={'extra-width-60'}>Exclude</th>
							</tr>
						</thead>
						<tbody>
							{errors.map(e => {
								return (
									<tr key={e.id} className={this.state.fadeTask && this.state.fadeTask === e.id ? 'hidden' : `visible ${e.bugDuty}`}>
										<td className={'elem-checkbox'}>
											<input checked={e.fixed} type="checkbox" onChange={this.handleFixed.bind(this, e)} />
										</td>
										<td>
											<span className={'elem'}>{e.actualId}</span>
										</td>
										<td>
											<span className={'elem'}>{e.lastUpdatedByName}</span>
										</td>
										<td>
											<span className={'elem'}>{e.timestamp}</span>
										</td>
										<td>
											<span className={'elem'}>
												{e.companyName + ' #' + e.companyId} <br /> {e.personName + ' #' + e.personId}{' '}
											</span>
										</td>
										<td>
											<span className={'elem'}>{e.url}</span>
										</td>
										<td className={'notes-cell'}>
											<TextAreaFoldout placeholder={'Notes'} value={e.notes} onBlur={this.handleNotes.bind(this, e)} maxChars={300} />
										</td>
										<td>
											{e.correlationId && e.correlationId !== '' ? (
												<>
													<a
														className={'elem'}
														target="_blank"
														rel="noopener noreferrer"
														href={`https://app.datadoghq.eu/logs?cols=service%2C%40level&event&from_ts=${new Date().getTime() - 604800000}&index=&live=true&messageDisplay=inline&query=%40correlationId%3A${
															e.correlationId
														}&stream_sort=desc&to_ts=${new Date().getTime()}`}
													>
														{e.correlationId}
													</a>
													&nbsp;&nbsp;&nbsp;
													<a
														className={'elem'}
														target="_blank"
														rel="noopener noreferrer"
														href={
															"https://426a4bc1296648d08cb5942bcd013b16.eu-west-1.aws.found.io:9243/app/kibana#/discover?_g=(refreshInterval:(pause:!t,value:0),time:(from:now-7d,mode:quick,to:now))&_a=(columns:!(level,logger,message),filters:!(('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'381e9e4a-aeb3-4990-a31c-e9346df89392',key:correlationId,negate:!f,params:(query:'" +
															e.correlationId +
															"',type:phrase),type:phrase,value:'" +
															e.correlationId +
															"'),query:(match:(correlationId:(query:'" +
															e.correlationId +
															"',type:phrase))))),index:'93051910-fc44-11e7-9b31-e39da2a67b27',interval:auto,query:(language:lucene,query:''),sort:!('@timestamp',desc))"
														}
													>
														Kibana
													</a>
												</>
											) : (
												'-'
											)}
										</td>
										<td>
											<a className={'elem'} target="_blank" rel="noopener noreferrer" href={'https://sentry.io/organizations/forecast/issues/?project=131628&query=is%3Aunresolved+user.id%3A' + e.personId}>
												Sentry
											</a>
											{e.sentryEventId && e.sentryEventId !== '' && (
												<>
													{' - '}
													<a className={'elem'} target="_blank" rel="noopener noreferrer" href={`https://sentry.io/organizations/forecast/?query=${e.sentryEventId}`}>
														{'Direct Link'}
													</a>
												</>
											)}
										</td>
										<td>
											<a
												className={'elem'}
												target="_blank"
												rel="noopener noreferrer"
												href={
													'https://app.logrocket.com/forecast/forecast-nod93?filters=%5B%7B%22type%22%3A%22userID%22%2C%22operator%22%3A%7B%22name%22%3A%22is%22%2C%22type%22%3A%22IS%22%2C%22hasStrings%22%3Atrue%2C%22autocompleteEnabled%22%3Atrue%7D%2C%22strings%22%3A%5B%22' +
													e.personId +
													'%22%5D%7D%5D'
												}
											>
												Logrocket
											</a>
										</td>
										<td className="team-dropdown" spellcheck="false">
											<Dropdown focusOnClick={true} optionClickEvent={true} onChange={this.handleTeam.bind(this, e)} options={allTeams} value={e.team} hideLabel={true} disabled={false} />
										</td>
										<td className="team-dropdown" spellcheck="false">
											<Dropdown focusOnClick={true} optionClickEvent={true} onChange={this.handleErrorTypeChange.bind(this, e)} options={errorTypes} value={e.knownType} hideLabel={true} disabled={false} />
										</td>
										<td className={'elem-checkbox'}>
											<input checked={e.excludeFromStats} type="checkbox" onChange={this.handleExclude.bind(this, e)} />
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				) : (
					<div className={'state-center'}>
						<EmptyState pageName={EMPTY_STATE.NO_ERRORS}></EmptyState>
					</div>
				)}
			</Scrollbars>
		);
	}

	render() {
		if (!this.props.viewer.missionControlData) {
			this.props.history.push('/not-found');
			return null;
		}

		if (!this.props.viewer.missionControlData.errorList) {
			return null;
		}

		return (
			<div className="mission-control-bug-duty">
				<div className={`header-container`}>{this.getHeader()}</div>
				<div className={`mission-control-bug-duty-container`}>{this.getBugsList()}</div>
				<br />
			</div>
		);
	}
}

const bugDutyQuery = graphql`
	query bugDuty_Query($searchString: String) {
		viewer {
			actualPersonId
			component(name: "control_bug_duty")
			...bugDuty_viewer @arguments(searchString: $searchString)
		}
	}
`;

export {bugDutyQuery};

export default withRouter(
	createRefetchContainer(
		bugDuty,
		{
			viewer: graphql`
				fragment bugDuty_viewer on Viewer @argumentDefinitions(searchString: {type: "String"}) {
					id
					missionControlData {
						id
						errorList(searchString: $searchString) {
							id
							actualId
							timestamp
							personId
							personName
							companyId
							companyName
							correlationId
							sentryEventId
							fixed
							notes
							excludeFromStats
							lastUpdatedByName
							bugDuty
							team
							url
							knownType
						}
						devChannels {
							id
							name
						}
						knownErrorTypes {
							id
							name
							description
						}
						selectedDevChannel {
							id
						}
					}
				}
			`,
		},
		graphql`
			query bugDutyRefetchQuery($searchString: String) {
				viewer {
					...bugDuty_viewer @arguments(searchString: $searchString)
				}
			}
		`
	)
);
